import { Component, HostListener, OnInit } from '@angular/core';

@Component({
    // Root selector is hardcoded in apps/portal/src/index.html (bootstrap element); renaming needs
    // a coordinated index.html change.
    // eslint-disable-next-line @angular-eslint/component-selector -- see comment above
    selector: 'marketspace-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'portal';

  constructor() {
  }
}
